/**
 * Confirm two fields have the same value. For example, an email confirmation
 * or a password confirmation input. Looks for an additional
 * data-validate-confirm-for="" atribute on the confirmation element containing
 * the name of the field we are confirming.
 * @constructor
 * @param {Foundation.Form} form
 * @implements {Foundation.Form.Validator}
 */
Foundation.Form.Validator.Confirm = function (form) {
    this.form = form;
};

Foundation.Form.Validator.Confirm.prototype.identifier = function () {
    return "confirm";
};

/**
 * @param {jQuery} fieldElements
 * @return {Foundation.Promise}
 */
Foundation.Form.Validator.Confirm.prototype.validate = function (fieldElements) {
    var result = new Foundation.Promise();
        
    var errorArray = [];
    fieldElements.filter("[data-validate-confirm-for]").each(function (i, element) {
        var confField = jQuery(element);
        var confName = confField.attr("name");
        var origName = confField.data("validateConfirmFor");
        var origField = this.form.elementForField(origName);
        
        if (origField[0] && origField.val().toLowerCase() !== confField.val().toLowerCase()) {
            // Determine the error message.
            var message = "Confirmation field must match original.";
            var fieldLabel = this.form.labelForField(origName);
            var confFieldLabel = this.form.labelForField(confName);
            if (fieldLabel && confFieldLabel) {
                message = `"${fieldLabel}" and "${confFieldLabel}" must match.`;
            }
            
            errorArray.push({
                "message": message,
                "fields": [origName, confName]
            });
        }
        else {
            if (!confField[0]) {
                Foundation.warn("confirm-for: No matching field '%s'.", origName);
            }
        }
    }.bind(this));
        
    if (errorArray.length) {
        result.set("errors", errorArray);
        result.fail();
    }
    else {
        result.fulfill();
    }
    
    return result;
};

Foundation.Form.registerValidator(Foundation.Form.Validator.Confirm);
